export const APP_NAME = 'Inspectaly';

// Set REACT_APP_API_BASE_URL in .env. CRA inlines it at build time, so the
// production build must be made on the server (or with the production .env
// present) - changing it afterwards means rebuilding.
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/api';


export const USER_PERMISSIONS = {
	ADD_PROPERTY: 'ADD_PROPERTY',
	UPDATE_PROPERTY: 'UPDATE_PROPERTY',
	CREATE_INSPECTION: 'CREATE_INSPECTION',
	PERFORM_INSPECTION: 'PERFORM_INSPECTION',
	VIEW_INSPECTION_REPORT: 'VIEW_INSPECTION_REPORT',
	DELETE_INSPECTION: 'DELETE_INSPECTION',
	MANAGE_RENTER_CONNECTION: 'MANAGE_RENTER_CONNECTION',
	MANAGE_TEMPLATES: 'MANAGE_TEMPLATES',
	MANAGE_USERS: 'MANAGE_USERS',
}

export const USER_PERMISSIONS_LABELS = {
	ADD_PROPERTY: 'Add Property',
	UPDATE_PROPERTY: 'Update Property',
	CREATE_INSPECTION: 'Create Inspection',
	PERFORM_INSPECTION: 'Perform Inspection',
	VIEW_INSPECTION_REPORT: 'View Inspection Reports',
	DELETE_INSPECTION: 'Delete Inspection',
	MANAGE_RENTER_CONNECTION: 'Manage Renter Connection',
	MANAGE_TEMPLATES: 'Manage Templates',
	MANAGE_USERS: 'Manage Users',
}


export const checkPermission = (permission) => {
	try {
		const userData = JSON.parse(localStorage.getItem('userData'));
		if (!userData) {
			return false;
		}

		if (userData.type != 'MANAGER') {
			return true;
		}

		if (userData.permissions && userData.permissions.includes(permission)) {
			return true;
		}
		
		return false;
	} catch (error) {
		console.error("Error parsing user data:", error);
		return false;
	}
}